import { IState } from "../vuex/IState";
import { Store } from "vuex";

export function setFavIco(store: Store<IState>): void {
  const favIcoLink = document.querySelector("link[rel*='icon']") as HTMLAnchorElement;
  favIcoLink.href = store.getters.currentTenantSquareLogoPath;
}
